import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/usr/usergroups', params),
    getById: (id) => Api.get('/usr/usergroup/' + id, null),
    save: (entity) => Api.post('/usr/usergroup', entity),
    update: (id, entity) => Api.put('/usr/usergroup/' + id, entity),
    delete: (id) => Api.delete('/usr/usergroup/' + id),
    search: (searchText) => Api.get('/usr/usergroups/search', {q: searchText}),
    getMembers: (id, params) => Api.get(`/usr/usergroup/${id}/members`, params),
};